(function () {
  "use strict";

  function $(sel, root) {
    return (root || document).querySelector(sel);
  }

  function $$(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  function cleanHtmlSpacing(htmlString) {
    if (!htmlString) return htmlString;
    var t = document.createElement("div");
    t.innerHTML = htmlString;
    
    function cleanFirstChild(el) {
       var first = el.firstChild;
       if (!first) return false;
       if (first.nodeType === 3 && first.textContent.trim() === "") {
           first.remove();
           return true;
       }
       if (first.nodeType === 1 && first.tagName.toLowerCase() === "br") {
           first.remove();
           return true;
       }
       if (first.nodeType === 1 && first.tagName.toLowerCase() === "p") {
           if (cleanFirstChild(first)) return true;
           if (first.innerHTML.trim() === "") {
               first.remove();
               return true;
           }
       }
       return false;
    }

    function cleanLastChild(el) {
       var last = el.lastChild;
       if (!last) return false;
       if (last.nodeType === 3 && last.textContent.trim() === "") {
           last.remove();
           return true;
       }
       if (last.nodeType === 1 && last.tagName.toLowerCase() === "br") {
           last.remove();
           return true;
       }
       if (last.nodeType === 1 && last.tagName.toLowerCase() === "p") {
           if (cleanLastChild(last)) return true;
           if (last.innerHTML.trim() === "") {
               last.remove();
               return true;
           }
       }
       return false;
    }
    
    while(cleanFirstChild(t)) {}
    while(cleanLastChild(t)) {}
    
    return t.innerHTML.trim();
  }

  function parseDescriptionAccordion(html) {
    var result = { fabric: "", sizeFit: "", about: "", pleaseNote: "" };
    if (!html) return result;

    var markers = [
        { key: "fabric", regex: /(?:<p[^>]*>\s*|<strong[^>]*>\s*|<span[^>]*>\s*|<div[^>]*>\s*)*(PRODUCT\s*DETAILS)(?:\s*<\/strong>|\s*<\/span>|\s*<\/div>|\s*<\/p>|\s*<br\s*\/?>)*/i },
        { key: "sizeFit", regex: /(?:<p[^>]*>\s*|<strong[^>]*>\s*|<span[^>]*>\s*|<div[^>]*>\s*)*(SIZE\s*(?:AND|&)\s*FIT:?)(?:\s*<\/strong>|\s*<\/span>|\s*<\/div>|\s*<\/p>|\s*<br\s*\/?>)*/i },
        { key: "pleaseNote", regex: /(?:<p[^>]*>\s*|<strong[^>]*>\s*|<span[^>]*>\s*|<div[^>]*>\s*)*(PLEASE\s*NOTE:?)(?:\s*<\/strong>|\s*<\/span>|\s*<\/div>|\s*<\/p>|\s*<br\s*\/?>)*/i },
        { key: "about", regex: /(?:<p[^>]*>\s*|<strong[^>]*>\s*|<span[^>]*>\s*|<div[^>]*>\s*)*(PRODUCT\s*DESCRIPTION)(?:\s*<\/strong>|\s*<\/span>|\s*<\/div>|\s*<\/p>|\s*<br\s*\/?>)*/i }
    ];

    var foundMarkers = [];
    markers.forEach(function(m) {
        var match = html.match(m.regex);
        if (match) {
            foundMarkers.push({ key: m.key, index: match.index, length: match[0].length });
        }
    });
    
    // Sort markers by their appearance in the HTML
    foundMarkers.sort(function(a, b) { return a.index - b.index; });

    if (foundMarkers.length === 0) {
        // No headers found. Treat everything as 'about' initially.
        result.about = html;
    } else {
        // Text before the first header defaults to 'about'
        var firstIdx = foundMarkers[0].index;
        if (firstIdx > 0) {
            result.about += html.substring(0, firstIdx);
        }
        
        for (var i = 0; i < foundMarkers.length; i++) {
            var current = foundMarkers[i];
            var next = foundMarkers[i+1];
            var startSlice = current.index + current.length;
            var endSlice = next ? next.index : html.length;
            
            result[current.key] += html.substring(startSlice, endSlice);
        }
    }

    // Heuristic: Extract dense prose paragraphs from other sections and move them to 'about'.
    // This handles the case where "About" text is dumped at the bottom without a header.
    function extractAboutText(sourceHtml) {
        var extractedHtml = "";
        var temp = document.createElement("div");
        temp.innerHTML = sourceHtml;
        var elements = temp.querySelectorAll("p, span, div");
        var toExtract = [];
        
        for (var i = 0; i < elements.length; i++) {
            var el = elements[i];
            var text = el.textContent.replace(/\s+/g, " ").trim();
            
            if (text.length < 80 || el.querySelector('li')) continue;
            
            // Prose heuristic: 
            // Fabric details use "Key: Value" (contains colon) and are usually short.
            // About text is prose: it rarely contains colons unless it's a massive paragraph.
            var hasColon = text.indexOf(":") !== -1;
            var isProse = (text.length > 200) || (text.length > 100 && !hasColon);
            
            if (isProse && !text.toLowerCase().includes("mrp:")) {
                var isContained = false;
                for (var j = 0; j < toExtract.length; j++) {
                   if (toExtract[j].contains(el) || el.contains(toExtract[j])) {
                       isContained = true;
                       break;
                   }
                }
                if (!isContained) {
                   toExtract.push(el);
                }
            }
        }
        
        toExtract.forEach(function(el) {
           extractedHtml += el.outerHTML;
           el.remove();
        });
        
        return { extracted: extractedHtml, remaining: temp.innerHTML };
    }

    // Run extraction on pleaseNote and fabric
    var noteExtraction = extractAboutText(result.pleaseNote);
    result.pleaseNote = noteExtraction.remaining;
    result.about += noteExtraction.extracted;

    var fabricExtraction = extractAboutText(result.fabric);
    result.fabric = fabricExtraction.remaining;
    result.about += fabricExtraction.extracted;

    // Clean up HTML formatting (let browser heal dangling tags via innerHTML internally inside cleanHtmlSpacing)
    result.fabric = cleanHtmlSpacing(result.fabric.replace(/^[\s:;]+/, "").replace(/^(?:<br\s*\/?>|<p>\s*<\/p>)+/i, ""));
    result.sizeFit = cleanHtmlSpacing(result.sizeFit.replace(/^[\s:;]+/, "").replace(/^(?:<br\s*\/?>|<p>\s*<\/p>)+/i, ""));
    result.pleaseNote = cleanHtmlSpacing(result.pleaseNote.replace(/^[\s:;]+/, "").replace(/^(?:<br\s*\/?>|<p>\s*<\/p>)+/i, ""));
    result.about = cleanHtmlSpacing(result.about.replace(/^[\s:;]+/, "").replace(/^(?:<br\s*\/?>|<p>\s*<\/p>)+/i, ""));

    return result;
  }

  function formatFabricHtml(raw) {
    if (!raw) return "<p>Details not available.</p>";
    if (raw.indexOf("<") !== -1) {
      return raw.indexOf("<p") === -1
        ? '<div class="rte"><p>' + raw + "</p></div>"
        : '<div class="rte">' + raw + "</div>";
    }
    return (
      '<div class="rte"><p>' +
      escapeHtml(raw).replace(/\n/g, "<br>") +
      "</p></div>"
    );
  }

  function formatSizeFitHtml(raw) {
    if (!raw) return "<p>Size information not available.</p>";
    if (raw.indexOf("<") !== -1) {
      return raw.indexOf("<p") === -1
        ? '<div class="rte bc-ab-size-fit"><p>' + raw + "</p></div>"
        : '<div class="rte bc-ab-size-fit">' + raw + "</div>";
    }
    return (
      '<div class="rte bc-ab-size-fit"><p>' +
      escapeHtml(raw).replace(/\n/g, "<br>") +
      "</p></div>"
    );
  }

  function findReviewsWidget() {
    return (
      document.getElementById("judgeme_product_reviews") ||
      document.querySelector(".jdgm-widget.jdgm-review-widget")
    );
  }

  function getStickyHeaderOffset() {
    var selectors = [
      "header.sticky-header",
      ".shopify-section-header-sticky",
      ".section-header",
      ".header-wrapper",
      "header",
      "#shopify-section-header",
    ];
    for (var i = 0; i < selectors.length; i++) {
      var elements = document.querySelectorAll(selectors[i]);
      for (var j = 0; j < elements.length; j++) {
        var el = elements[j];
        var style = window.getComputedStyle(el);
        if (
          style &&
          (style.position === "fixed" || style.position === "sticky")
        ) {
          var h = el.offsetHeight;
          if (h > 30 && h < 200) {
            return h + 15;
          }
        }
      }
    }
    return 80;
  }

  function setActiveTab(root, tabId) {
    var nav = $(".bc-ab-tab-nav", root);

    // Step 1: Switch the active tab classes (this changes the panel content & height)
    $$(".bc-ab-tab-btn", root).forEach(function (btn) {
      var on = btn.getAttribute("data-tab") === tabId;
      btn.classList.toggle("is-active", on);
      btn.setAttribute("aria-selected", on ? "true" : "false");
    });
    $$(".bc-ab-tab-panel", root).forEach(function (panel) {
      panel.classList.toggle(
        "is-active",
        panel.getAttribute("data-panel") === tabId,
      );
    });

    // Step 2: After switch, check if tab nav is in the "ideal zone" (top 30% of viewport,
    // just below the sticky header). If not, scroll to bring it there — maximizing visible
    // content area below the tabs. If already in the zone, do nothing (gallery stays still).
    if (nav) {
      requestAnimationFrame(function () {
        var rect = nav.getBoundingClientRect();
        var headerOffset = getStickyHeaderOffset();
        var viewportHeight = window.innerHeight;

        // Ideal position: tab nav top sits just below the sticky header
        var idealTop = headerOffset + 16;

        // Acceptable zone: nav is between the header and 30% down the viewport.
        // This ensures the nav is near the top so content below is fully visible.
        var inIdealZone = rect.top >= headerOffset && rect.top <= viewportHeight * 0.30;

        if (!inIdealZone) {
          // Scroll precisely so nav.top lands at idealTop
          window.scrollBy({ top: rect.top - idealTop, behavior: "smooth" });
        }
        // If already in ideal zone → do nothing, gallery stays perfectly still
      });
    }
  }

  function attachReviews(attempt) {
    var host = document.getElementById("bc-ab-reviews-host");
    if (!host) return;

    var widget = findReviewsWidget();
    if (widget) {
      if (host.contains(widget)) return;

      var sectionWrapper = widget.closest(".shopify-section");
      if (sectionWrapper) {
        sectionWrapper.classList.add("bc-ab-reviews-moved");
      }
      host.innerHTML = "";
      host.appendChild(widget);
      return;
    }

    if (attempt < 20) {
      setTimeout(function () {
        attachReviews(attempt + 1);
      }, 400);
    } else {
      host.innerHTML =
        "<p>Reviews are not available on this page right now. Please refresh or scroll to the reviews section.</p>";
    }
  }

  function init() {
    var root = document.getElementById("bc-ab-product-tabs-wrapper");
    if (!root) return;
    
    // Check if we've already initialized
    if (root.dataset.initialized === "true") return;
    root.dataset.initialized = "true";

    // Grab raw description
    var rawDescEl = document.getElementById("bc-ab-raw-description");
    if (rawDescEl) {
      var parsedDesc = parseDescriptionAccordion(rawDescEl.innerHTML);
      
      var sizeFitPanel = document.getElementById("bc-ab-panel-size-fit");
      var sizeFitBtn = document.getElementById("bc-ab-tab-size-fit");
      if (parsedDesc.sizeFit) {
          if (sizeFitPanel) sizeFitPanel.innerHTML = formatSizeFitHtml(parsedDesc.sizeFit);
      } else {
          if (sizeFitPanel) sizeFitPanel.remove();
          if (sizeFitBtn) sizeFitBtn.remove();
      }
      
      var fabricPanel = document.getElementById("bc-ab-panel-fabric-care");
      var fabricBtn = document.getElementById("bc-ab-tab-fabric-care");
      if (parsedDesc.fabric) {
          if (fabricPanel) fabricPanel.innerHTML = formatFabricHtml(parsedDesc.fabric);
      } else {
          if (fabricPanel) fabricPanel.remove();
          if (fabricBtn) fabricBtn.remove();
      }
      
      var aboutPanel = document.getElementById("bc-ab-panel-about");
      var aboutBtn = document.getElementById("bc-ab-tab-about");
      if (parsedDesc.about) {
          if (aboutPanel) aboutPanel.innerHTML = parsedDesc.about;
      } else {
          if (aboutPanel) aboutPanel.remove();
          if (aboutBtn) aboutBtn.remove();
      }

      var pleaseNoteEl = document.getElementById("bc-ab-please-note");
      var pleaseNoteContainer = document.getElementById("bc-ab-please-note-container");
      if (parsedDesc.pleaseNote) {
          if (pleaseNoteEl) pleaseNoteEl.innerHTML = '<div class="rte">' + parsedDesc.pleaseNote + '</div>';
      } else {
          // If no please note, just leave it blank (other_info_content might still render below it)
      }
      
      // Ensure the first visible tab is active if Size & Fit was removed and it was the default active tab
      var activeBtn = document.querySelector(".bc-ab-tab-btn.is-active");
      if (!activeBtn) {
          var firstBtn = document.querySelector(".bc-ab-tab-btn");
          if (firstBtn) {
              firstBtn.classList.add("is-active");
              var panelId = firstBtn.getAttribute("data-tab");
              var firstPanel = document.getElementById("bc-ab-panel-" + panelId);
              if (firstPanel) firstPanel.classList.add("is-active");
          }
      }
    }

    root.addEventListener("click", function (e) {
      var btn = e.target.closest(".bc-ab-tab-btn");
      if (!btn) return;
      e.preventDefault();
      var tabId = btn.getAttribute("data-tab");
      setActiveTab(root, tabId);

      setTimeout(function () {
        if (btn.classList.contains("is-active")) {
          setActiveTab(root, tabId);
        }
      }, 200);
    });

    if (document.getElementById("bc-ab-reviews-host")) {
        attachReviews(0);
    }
  }

  function run() {
    try {
      init();
    } catch (err) {
      console.warn("[BC Product Tabs]", err);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run);
  } else {
    run();
  }

  document.addEventListener("shopify:section:load", run);
})();
